// react
import React from "react";

// components
import TextInput from "../../../../components/Inputs/TextInput";

// dependencies
import PropTypes from "../../../../lib/prop-types";

// utils
// styles
import css from "../SftpSettings.module.scss";

const AddIntegrationName = (props) => {
	const { integrationName, setSftpIntegrationName } = props;

	return (
		<div>
			<div className={css.inputWrapper}>
				<div className={css.modalDescription}>Integration Name/Description:</div>
				<div className={css.modalInput}>
					<TextInput
						style={{ width: "90%" }}
						maxLength={30}
						value={integrationName}
						onChange={(val) => setSftpIntegrationName(val)}
					/>
				</div>
			</div>
		</div>
	);
};

AddIntegrationName.propTypes = {
	integrationName: PropTypes.string.isRequired,
	setSftpIntegrationName: PropTypes.func.isRequired,
};

export default AddIntegrationName;
